import React from 'react'
import { Item, Loader, Message, Icon } from 'semantic-ui-react';

import usePlants from '../hooks/usePlants';
import { BaseUser, Plant } from '../../../src/types';
import SensorGraph from './SensorGraph';
import { Link } from 'react-router-dom';
import AddPlantModal from './AddPlantModal';



const PlantItem = ({ plant }: { plant: Plant }) => {
    const currentMoisture =  plant.readings?.length
    ? plant.readings[plant.readings.length - 1].moisture.toFixed(2)
    : "N/A"

    return (
        <Item as={Link} to={`/plants/${plant.id}`}>
            <Item.Image src={plant.imageURL} size="medium"/>
            <Item.Content>
                <Item.Header>
                    {plant.name}
                    {plant.watering &&
                    <Icon color="blue" name="tint" title="watering..."/>
                    }
                    {plant.calibrating &&
                    <Icon color="green" name="sync" title="calibrating..."/>
                    }
                </Item.Header>
                <Item.Meta>
                    moisture: <span style={{color:"blue"}}>{currentMoisture}%</span>
                </Item.Meta>            
            </Item.Content>
        </Item>
    );
};

const PlantsList = ({ user }: { user: BaseUser|undefined }) => {
    const { plants, error, loading } = usePlants();

    if (loading) {
        return <Loader active/>
    }
    
    if (error) {
        return <Message negative> {error} </Message>
    }
    return (
        <>
            <Item.Group divided>
                {plants.map(plant => 
                    <PlantItem plant={plant} key={plant.id}/>
                )}
            </Item.Group>
        </>
    );
}

export default PlantsList;